import {
  EMPLOYER_DEFAULT_MOTIVATION_QUESTIONS,
  EMPLOYER_MOTIVATION_QUESTIONS_MAX
} from '@profilpublic/api-contract/employer'

export function getEmployerAcronym(employer) {
  return employer.careerSite?.acronym || ''
}

export function getEmployerCover(employer) {
  return employer.careerSite?.cover || null
}

export function getEmployerDescription(employer) {
  return (employer.careerSite?.introText || employer.description)?.replace(/(<([^>]+)>)/g, '')
}

export function getEmployerLogo(employer) {
  return employer.careerSite?.logo || employer.logo || null
}

export function getEmployerWebsite(employer) {
  return employer.careerSite?.website || ''
}

// All three columns empty means never configured: fall back to the defaults.
export function resolveMotivationQuestions(employer) {
  const questions = [employer?.motivationQuestion1, employer?.motivationQuestion2, employer?.motivationQuestion3].filter(
    question => typeof question === 'string' && question.trim()
  )
  return questions.length ? questions : [...EMPLOYER_DEFAULT_MOTIVATION_QUESTIONS]
}

// Compact a dynamic questions array into the three persisted employer columns.
// Freed slots are explicitly nulled so deletions stick in the database.
export function toMotivationQuestionFields(questions = []) {
  const normalized = questions
    .map(question => (typeof question === 'string' ? question.trim() : ''))
    .filter(Boolean)
    .slice(0, EMPLOYER_MOTIVATION_QUESTIONS_MAX)

  return {
    motivationQuestion1: normalized[0] ?? null,
    motivationQuestion2: normalized[1] ?? null,
    motivationQuestion3: normalized[2] ?? null
  }
}
